import { useEffect } from 'react';
import { generateSideBarButtons, setSideBarButtons } from 'src/sidebar/sidebar-operation';

export const useSidebarButtons = (sellingMode, posMode, showSidebar, tenderingMode) => {
  useEffect((): void => {
    const mode = tenderingMode
      ? 'tenderMode'
      : posMode.returnMode.returnType
      ? 'returnMode'
      : sellingMode;
    const sideBarButtons = generateSideBarButtons(mode, showSidebar);
    setSideBarButtons(sideBarButtons);
  }, [sellingMode, posMode, showSidebar, tenderingMode]);
};
